import {
  QUERY_PARAM_PARENT_PRODUCT,
  QUERY_PARAM_PRESENTATION_MODE,
} from '@canvas/constants/query-params';

/**
 * NATIVE_EMBED is currently experimental.
 *
 */
export type AppMode =
  | 'STANDALONE'
  | 'EMBED'
  | 'MOBILE'
  | 'NATIVE_EMBED'
  | 'NATIVE_EMBED_EDITOR_PLUGIN';

let APP_MODE: AppMode = 'STANDALONE';

export const QUERY_PARAM_MOBILE_APP = 'mobileApp';
export const QUERY_PARAM_EMBEDDED = 'embedded';
export const QUERY_PARAM_SMART_LINK = 'smartLink';
export const QUERY_PARAM_NATIVE_EMBED = 'nativeEmbed';
export const QUERY_PARAM_NATIVE_EMBED_EDITOR_PLUGIN = 'nativeEmbedEditorPlugin';

export type PresentationMode =
  | typeof QUERY_PARAM_NATIVE_EMBED
  | typeof QUERY_PARAM_NATIVE_EMBED_EDITOR_PLUGIN
  | typeof QUERY_PARAM_MOBILE_APP;

export const setAppMode = (mode: AppMode): void => {
  APP_MODE = mode;
};

export function getAppMode() {
  return APP_MODE;
}

export const getAppModeFromQueryParams = (urlSearchParams: URLSearchParams): AppMode => {
  const isMobile =
    urlSearchParams.get(QUERY_PARAM_PARENT_PRODUCT) === QUERY_PARAM_MOBILE_APP ||
    urlSearchParams.get(QUERY_PARAM_PRESENTATION_MODE) === QUERY_PARAM_MOBILE_APP;

  if (isMobile) {
    return 'MOBILE';
  }

  // TODO: consolidate `embedded` and `parentProduct`, prefer `parentProduct` as
  // `embedded` is only used in local dev mode
  const isEmbedded =
    urlSearchParams.has(QUERY_PARAM_EMBEDDED) ||
    urlSearchParams.get(QUERY_PARAM_PARENT_PRODUCT) === QUERY_PARAM_SMART_LINK;

  if (
    isEmbedded &&
    urlSearchParams.get(QUERY_PARAM_PRESENTATION_MODE) === QUERY_PARAM_NATIVE_EMBED
  ) {
    return 'NATIVE_EMBED';
  }

  if (
    isEmbedded &&
    urlSearchParams.get(QUERY_PARAM_PRESENTATION_MODE) ===
      QUERY_PARAM_NATIVE_EMBED_EDITOR_PLUGIN
  ) {
    return 'NATIVE_EMBED_EDITOR_PLUGIN';
  }

  if (isEmbedded) {
    return 'EMBED';
  }

  return 'STANDALONE';
};

export function isStandalone(): boolean {
  return APP_MODE === 'STANDALONE';
}

export function isEmbed(): boolean {
  return APP_MODE === 'EMBED';
}

export function isMobile(): boolean {
  return APP_MODE === 'MOBILE';
}

export function isNativeEmbed(): boolean {
  return APP_MODE === 'NATIVE_EMBED';
}

export function isNativeEmbedEditorPlugin(): boolean {
  return APP_MODE === 'NATIVE_EMBED_EDITOR_PLUGIN';
}

export function isAnyNativeEmbed(): boolean {
  return isNativeEmbed() || isNativeEmbedEditorPlugin();
}
